import { ImageAnnotator } from '@/components/features/imageAnnotation'
import NotFound from '@/components/utils/NotFound'
import RouteLoadFailed from '@/components/utils/RouteLoadFailed'
import { usePermissionCheck } from '@/hooks/usePermissionCheck'
import { throwLoaderError } from '@/lib/loader-errors'
import { createFileRoute } from '@tanstack/react-router'

import { isEditableAssetSetType } from '@droidmap/asset-service-contract'
import { Permission } from '@droidmap/permissions-service-contract'

export const Route = createFileRoute(
  '/_authenticated/orgs/$orgId_/projects/$projectId_/_pathless/asset-sets/$assetSetId_/annotate',
)({
  loader: async ({ params, context }) => {
    const { assetSetId } = params
    const { assetClient } = context.client
    try {
      const assetSet = await assetClient.getAssetSet(
        { assetSetId },
        context.metadata,
      )
      return {
        crumb: 'label for ML',
        layout: { variant: 'workspace' as const },
        assetSet,
        assetClient,
        metadata: context.metadata,
      }
    } catch (error) {
      throwLoaderError(error, 'asset set')
    }
  },
  component: AnnotateRoute,
  notFoundComponent: () => <NotFound resource="Asset Set" />,
  errorComponent: () => <RouteLoadFailed resource="asset set" />,
})

function AnnotateRoute() {
  const { assetSet, assetClient, metadata } = Route.useLoaderData()
  const { orgId, projectId } = Route.useParams()
  const { hasPermission } = usePermissionCheck()

  return (
    <ImageAnnotator
      assetClient={assetClient}
      assetSetId={assetSet.id}
      assetSetName={assetSet.name}
      orgId={orgId}
      projectId={projectId}
      metadata={metadata}
      editable={hasPermission(Permission.UPDATE_ASSET)}
      canSaveToSet={
        hasPermission(Permission.CREATE_ASSET) &&
        isEditableAssetSetType(assetSet.assetSetType)
      }
      canCreateSet={hasPermission(Permission.CREATE_ASSET_SET)}
    />
  )
}
